// Hora oficial de la sala. Las funciones se muestran y se introducen siempre en hora
// de España, aunque el navegador del gestor esté configurado en otra zona.
export const TIME_ZONE = 'Europe/Madrid';

const formatters = new Map();
function formatter(options, locale = 'es-ES') {
    const key = locale + JSON.stringify(options);
    if (!formatters.has(key)) formatters.set(key, new Intl.DateTimeFormat(locale, { ...options, timeZone: TIME_ZONE }));
    return formatters.get(key);
}

/** Acepta milisegundos (número o texto numérico), una fecha ISO o un Date. */
export const dateValue = value => value instanceof Date ? value : new Date(/^\d+$/.test(String(value)) ? Number(value) : value);

/** «sábado, 24 de octubre, 19:00» (listados de obras y fechas del formulario). */
export const formatFuncion = value => formatter({ weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }).format(dateValue(value));
/** «24/10/26, 19:00» (entradas y aforo). */
export const formatCorto = value => formatter({ dateStyle: 'short', timeStyle: 'short' }).format(dateValue(value));
/** Fecha y hora completa con segundos (historial de movimientos). */
export const formatCompleto = value => formatter({ year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(dateValue(value));

/** Año, mes (1-12), día, hora y minuto de reloj de Madrid en ese instante. */
export function partesMadrid(value) {
    const p = Object.fromEntries(formatter({ year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }, 'en-CA')
        .formatToParts(dateValue(value)).map(x => [x.type, x.value]));
    return { year: Number(p.year), month: Number(p.month), day: Number(p.day), hour: Number(p.hour) % 24, minute: Number(p.minute) };
}

/** Hora de reloj de Madrid en ese instante, expresada como si fuera UTC. */
function madridWall(ms) {
    const p = partesMadrid(ms);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute);
}

/**
 * Convierte una hora de reloj de Madrid (mes 0-11) en milisegundos UTC, como los guarda la API.
 * Si la hora no existe (salto de primavera, 02:00-02:59) se adelanta una hora; si se repite
 * (otoño, 02:00-02:59) se toma la primera, en horario de verano.
 */
export function madridToEpoch(year, month, day, hour, minute) {
    const wall = Date.UTC(year, month, day, hour, minute);
    const summer = wall - 120 * 60000; const winter = wall - 60 * 60000;
    if (madridWall(summer) === wall) return summer;
    return winter; // invierno, o hora inexistente: 02:30 pasa a ser 03:30 de verano
}

/**
 * Combina el día pulsado en el calendario y la hora del selector (ambos objetos Date del
 * navegador) como hora de Madrid. Se toman los valores que ve el gestor en pantalla, sin
 * aplicar la zona del navegador.
 */
export const fechaFuncion = (day, time) => madridToEpoch(day.getFullYear(), day.getMonth(), day.getDate(), time.getHours(), time.getMinutes());

/** Medianoche (00:00 de Madrid) del día en que cae ese instante, en milisegundos UTC. */
export function inicioDiaMadrid(value) {
    const p = partesMadrid(value);
    return madridToEpoch(p.year, p.month - 1, p.day, 0, 0);
}
